import React, { HTMLAttributes, ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const rTStyles = css`
	p {
		margin: 0.5em 0;
	}

	ul {
		list-style-type: disc;
		margin: 0.5em 1em 0.5em 2em;

		li {
			display: list-item;
			padding: 0.4em 0;
			font-size: 1.2rem;
			line-height: 1.5rem;
		}
	}
`

const RTView = styled.div`
	${rTStyles}
`

export type RTProps = HTMLAttributes<HTMLDivElement> & {
	html?: string
	children?: ReactNode
}
export const RT = ({ html, children, className }: RTProps) => {
	return (
		<RTView className={`rt${className ? ` ${className}` : ''}`}>
			{html ? <div className='rt-content' dangerouslySetInnerHTML={{ __html: html }} /> : null}
			{children ? <div className='rt-content'>{children}</div> : null}
		</RTView>
	)
}
